import { v4 as uuidv4 } from 'uuid';

export function generateId(): string {
  return uuidv4();
}

export function generateDetailElementId(): number {
  // Generate a unique numeric ID based on timestamp
  return Date.now() + Math.floor(Math.random() * 1000);
}
